var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_8226_2281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9391 5.25191L10.1891 0.876914C10.0718 0.818372 9.93344 0.818372 9.81635 0.876914L1.06635 5.25191C0.925104 5.32254 0.835938 5.46671 0.835938 5.62462V14.3746C0.835938 14.5325 0.925104 14.6767 1.06615 14.7473L9.81614 19.1223C9.8749 19.1517 9.93865 19.1663 10.0026 19.1663C10.0666 19.1663 10.1303 19.1517 10.1891 19.1223L18.9391 14.7473C19.0801 14.6767 19.1693 14.5325 19.1693 14.3746V5.62462C19.1693 5.46671 19.0801 5.32254 18.9391 5.25191ZM10.0026 1.71546L17.8209 5.62462L16.1484 6.46087L8.33031 2.55171L10.0026 1.71546ZM12.8151 8.12754L4.99677 4.21837L7.39844 3.01754L15.2168 6.92671L12.8151 8.12754ZM13.1276 8.90296L15.6276 7.65296V10.7523L14.828 10.1813C14.7374 10.1165 14.6241 10.0909 14.5143 10.1098C14.4045 10.1292 14.3068 10.1915 14.2432 10.2832L13.1276 11.895V8.90296ZM4.0651 4.68421L11.8832 8.59337L10.0026 9.53379L2.18427 5.62462L4.0651 4.68421ZM1.66927 6.29879L9.58594 10.2571V18.0752L1.66927 14.1169V6.29879ZM10.4193 18.0755V10.2571L12.2943 9.31962V13.2288C12.2943 13.4111 12.4126 13.5721 12.5866 13.6265C12.6278 13.6394 12.6695 13.6455 12.7109 13.6455C12.8451 13.6455 12.9743 13.5805 13.0536 13.4661L14.688 11.1055L15.8024 11.9013C15.9295 11.9919 16.0966 12.0042 16.2351 11.9325C16.3736 11.8613 16.4609 11.7182 16.4609 11.5621V7.23629L18.3359 6.29879V14.1169L10.4193 18.0755Z",
    fill: "#E8E8DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8226_2281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductActive);
export default __webpack_public_path__ + "static/media/product_active.ca4478fc08fcdd681de7cf6a53a1fdb5.svg";
export { ForwardRef as ReactComponent };